import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ReactNode } from "react";
import { Spin } from "antd";
type ProtectedRouteProps = {
    module: string;
    action: string;
    children: ReactNode;
};

const ProtectedRoute = ({ module, action, children }: ProtectedRouteProps) => {
    const { hasPermission, permissionsLoaded, loadPermissions } = useAuth();
    useEffect(() => {
        if (!permissionsLoaded) {
            loadPermissions();
        }
    }, [permissionsLoaded]);

    if (!permissionsLoaded) {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh"
            }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!hasPermission(module, action)) {
        return <Navigate to="/NotFound" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
